<template>
  <nav v-if="length > 0" id="breadcrumb-navigation" data-component="BreadCrumbs" class="text-sm font-semibold leading-none">
    <AtomLink
      :url="last(trunkCrumbs).url"
      class="flex items-center text-xs leading-none sm:text-sm md:hidden"
      :class="{ 'text-white breadcrumb-text-shadow': darkModeMobile, 'text-black': !darkModeMobile }"
    >
      <AtomIconArrowLeft class="shrink-0 mr-2 w-3 h-3 text-app-green sm:w-4 sm:h-4 md:w-5 md:h-5" />
      <span class="underline font-bold">{{ last(trunkCrumbs).label }}</span>
    </AtomLink>
    <ol itemscope="" itemtype="http://schema.org/BreadcrumbList" class="hidden items-center md:flex">
      <li v-for="(crumb, index) in trunkCrumbs" :key="index" itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem" class="flex shrink-0 items-center">
        <AtomLink
          itemscope=""
          itemtype="http://schema.org/Thing"
          itemprop="item"
          :itemid="crumb.url"
          :url="crumb.url"
          class="flex shrink-0 items-center hover:text-app-green text-black underline transform transition duration-200"
        >
          <span itemprop="name">{{ crumb.label }}</span>
        </AtomLink>
        <meta itemprop="position" :content="index" />
        <span class="text-black mx-2" aria-hidden="true">/</span>
      </li>
      <li class="text-black">
        <span itemprop="name">{{ leafCrumb.label }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface BreadCrumbsProps {
  path: Array<{ url: string; label: string }>
  darkModeMobile?: boolean
}

const props = defineProps<BreadCrumbsProps>()

const length = computed(() => props.path?.length || 0)
const last = (list: Array<{ url: string; label: string }>) => list[list.length - 1]

const trunkCrumbs = computed(() => props.path?.slice(0, length.value - 1) || [])
const leafCrumb = computed(() => last(props.path))
</script>

<style lang="scss" scoped>
.breadcrumb-text-shadow {
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
</style>
